<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright">
<p class="center">Copyright © 2011 Simon and Schuster</p>
<p class="center">All rights reserved.</p>
<p class="center">This book, or parts thereof, may not be reproduced in any form without permission from the publisher; exceptions are made for brief excerpts used in published reviews.<br/><br/></p>
<p class="center">Published by<br/>
Adams Media, an imprint of Simon &amp; Schuster, Inc.<br/>
57 Littlefield Street, Avon, MA 02322. U.S.A.<br/>
<em><a href="http://www.adamsmedia.com" target="_blank">www.adamsmedia.com</a></em><br/><br/></p>
<p class="center">Contains material adapted and abridged from  <em>The Everything<sup>®</sup> Etiquette Book, 2nd Edition</em>, by Leah Ingram, copyright © 2005 Simon and Schuster, ISBN 10: 1-59337-383-X, ISBN 13: 978-1-59337-383-2.<br/><br/></p>
<p class="center">ISBN 10: 1-4405-1203-5<br/>
ISBN 13: 978-1-4405-1203-2<br/>
eISBN 10: 1-4405-2655-9<br/>
eISBN 13: 978-1-4405-2655-8<br/><br/></p>
<p class="center">Printed in the United States of America.<br/><br/></p>
<p class="center">10  9  8  7  6  5  4  3  2  1</p>
<p class="center"><strong>Library of Congress Cataloging-in-Publication Data</strong><br/>
is available from the publisher.<br/><br/></p>
<p class="nonindent">This publication is designed to provide accurate and authoritative information with regard to the subject matter covered. It is sold with the understanding that the publisher is not engaged in rendering legal, accounting, or other professional advice. If legal advice or other expert assistance is required, the services of a competent professional person should be sought.</p>
<p class="nonindent">—From a <em>Declaration of Principles</em> jointly adopted by a Committee of the American Bar Association and a Committee of Publishers and Associations<br/><br/></p>
<p class="center"><em>This book is available at quantity discounts for bulk purchases.</em></p>
<p class="center"><em>For information, please call 1-800-289-0963.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?37406e52